import { ACCESS } from "@dictybase/auth-mui5"
import { Show } from "../../../features/EditablePages/Show"

// eslint-disable-next-line unicorn/prefer-export-from, import/no-default-export
export default Show
export const access = ACCESS.public
